import ga from '@ott/google-analytics';
import { getOptions } from './options';

export const PAGE_DIMENSIONS = {
  TIMETABLE: 'searchresults',
  BOOK: 'book',
  PAY: 'pay',
};

const CITY_CODE_PREFIX = 'R';

export function clearDimensions() {
  const dimensions = {
    dimension11: null,
    dimension12: null,
    dimension13: null,
  };

  ga('set', dimensions);
}

export function setDimensions({ page, fromStationCode, toStationCode }) {
  const dimensions = {
    dimension11: fromStationCode && `${CITY_CODE_PREFIX}${fromStationCode}`,
    dimension12: toStationCode && `${CITY_CODE_PREFIX}${toStationCode}`,
    dimension13: page,
  };

  ga('set', dimensions);
}

export function sendPageView({ nonInteraction = false, sendIntentMedia = true } = {}) {
  ga('set', 'page', document.location.pathname + document.location.search);
  ga('set', 'hostname', document.location.hostname);
  ga('set', 'nonInteraction', nonInteraction);
  if (sendIntentMedia && getOptions().sendIntentMediaStats) {
    ga('send', 'pageview', {
      dimension19: 'IntentScore',
    });
  } else {
    ga('send', 'pageview');
  }
}

export function gaEvent(params) {
  if (getOptions().sendGAEvent) {
    ga('send', 'event', params.category, params.action, params.label, params.value);
  }
}
